import React from 'react';
import SubjectTitleModel from '../../models/SubjectTitleModel';

const SubjectTitle: React.FC<SubjectTitleModel> = (props) => {
    return (
        <div className='subject'>
          {props.title}
        </div>
    );
} 

export default SubjectTitle;